import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import { Redirect } from 'react-router-dom'
import { get } from 'lodash'
import Error from 'components/error'
import { useAuth } from 'lib/auth'
import { LessonReviewQuery, GetStudentQuery } from './query'
import LessonReviewLayout from './lesson-review-layout'
import SummaryLayout from './summary-layout'
import ReviewBookingSkeleton from './review-booking-skeleton'

const ReviewBooking = ({
  idOrSlug,
  lessonTypeId,
  locationId,
  startDateTime,
  studentId,
  previousUrl,
}) => {
  const fetchedLessonInfo = useQuery(LessonReviewQuery, {
    variables: {
      id: lessonTypeId,
    },
  })
  const fetchedStudent = useQuery(GetStudentQuery, {
    variables: {
      id: studentId,
    },
  })

  const { user } = useAuth()
  const coachIsViewingOwnSchedule =
    user?.coach?.coachProfile?.slug === idOrSlug ||
    user?.externalId === idOrSlug

  const [isComplete, setIsComplete] = useState(false)
  const [cardBrand, setCardBrand] = useState()
  const [lastDigits, setLastDigits] = useState()

  if (fetchedLessonInfo.error || fetchedStudent.error) {
    return <Error error={fetchedLessonInfo.error || fetchedStudent.error} />
  }
  if (fetchedLessonInfo.loading || fetchedStudent.loading) {
    return <ReviewBookingSkeleton />
  }
  return (
    <>
      {!isComplete ? (
        <LessonReviewLayout
          lessonType={get(fetchedLessonInfo.data, 'lessonTypes.0')}
          student={get(fetchedStudent.data, 'currentUser.students.0')}
          locationId={locationId}
          startDateTime={startDateTime}
          previousUrl={previousUrl}
          isComplete={isComplete}
          setIsComplete={setIsComplete}
          setCardBrand={setCardBrand}
          setLastDigits={setLastDigits}
          coachIsViewingOwnSchedule={coachIsViewingOwnSchedule}
        />
      ) : (
        <SummaryLayout
          lessonType={get(fetchedLessonInfo.data, 'lessonTypes.0')}
          student={get(fetchedStudent.data, 'currentUser.students.0')}
          idOrSlug={idOrSlug}
          lessonTypeId={lessonTypeId}
          locationId={locationId}
          startDateTime={startDateTime}
          previousUrl={previousUrl}
          cardBrand={cardBrand}
          lastDigits={lastDigits}
          isComplete={isComplete}
          coachIsViewingOwnSchedule={coachIsViewingOwnSchedule}
        />
      )}
    </>
  )
}

export default props => {
  const { isLoggedIn } = useAuth()
  if (!isLoggedIn) {
    return <Redirect to={props.previousUrl} />
  }
  return <ReviewBooking {...props} />
}
